import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";

const SignedDeclinePage = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-bg-gradient-to-br tw-from-[#FDD4D2] tw-to-white tw-flex tw-items-center tw-justify-center">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-8 tw-max-w-md tw-w-full tw-mx-4 tw-text-center">
        <div className="tw-mb-6">
          <CancelIcon
            className="tw-text-[#B42318] tw-animate-bounce"
            style={{ fontSize: "80px" }}
          />
        </div>

        <h1 className="tw-text-2xl tw-font-bold tw-text-[#B42318] tw-mb-4">
          Document Signing Declined
        </h1>

        <p className="tw-text-gray-600 tw-mb-8">
          The document signing process has been declined.
        </p>
      </div>
    </div>
  );
};

export default SignedDeclinePage;
